import { api } from '@/lib/api'
import type { ClusterStatus } from './types'

export async function getClusterStatus(): Promise<ClusterStatus> {
  const res = await api.get('/api/cluster/status')
  return res.data
}

export async function getClusterNodes(onlyOnline = false): Promise<{
  nodes: import('./types').ClusterNode[]
  total: number
}> {
  const res = await api.get(`/api/cluster/nodes?online=${onlyOnline}`)
  return res.data
}

export async function approveTrustedNode(nodeId: string) {
  const res = await api.post(`/api/cluster/nodes/${nodeId}/trust`)
  return res.data
}

export async function revokeTrustedNode(nodeId: string) {
  const res = await api.post(`/api/cluster/nodes/${nodeId}/untrust`)
  return res.data
}

export async function deleteClusterNode(nodeId: string) {
  const res = await api.delete(`/api/cluster/nodes/${nodeId}`)
  return res.data
}

export async function triggerBackup() {
  const res = await api.post('/api/cluster/backup/trigger')
  return res.data
}
